<template>
  <div class="user-menu-items">
    <div class="dropdown-header noti-title">
      <h6 class="text-overflow m-0">¡Bienvenido!</h6>
    </div>
    <div class="dropdown-divider"></div>
    <a v-if="$store.getters.isCommerce || $store.getters.isAssociatedCommerce" href="#" @click="changePasswordClick" class="dropdown-item">
      <i class="fas fa-key"></i>
      <span>Cambiar clave</span>
    </a>
    <a v-if="$store.getters.isCommerce || $store.getters.isAssociatedCommerce" href="#" @click="forgotMyPasswordClick" class="dropdown-item">
      <i class="fas fa-key"></i>
      <span>Olvide Mi Contraseña</span>
    </a>
    <a href="#" @click="logout" class="dropdown-item">
      <i class="fa fa-sign-out-alt"></i>
      <span>Salir</span>
    </a>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import confirmHelpers from "@/helpers/confirmHelpers";

export default {
  data() {
    return {};
  },
  beforeMount: function() {},
  methods: {
    logout() {
      let context = this;

      axiosHelpers.axiosPost("Account/Logout", {}, this, function(data) {
        if (data.ResponseVM != null) {
          context.$store.dispatch("logout").then(() => {
            context.$router.push("login");
          });
        }
      });
    },
    changePasswordClick() {
      let context = this;

      //-- Indica si tiene que Verificación de 2 pasos activa
      if (context.$store.getters.ShouldPerformTwoStepVerification) {
        context.$router.push({
          name: "InitialSelectSecurityMethod",
          params: {
            accumulationMethodTypeID: context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
            useRouterPush: true,
            dataPost: {
              name: "cambiar password"
            }
          }
        });
      } else {
        context.$router.push("/cambiarpassword");
      }
    },
    forgotMyPasswordClick() {
      let context = this;
      confirmHelpers.showConfirm(
        "Al confirmar, cerraremos tu sesión, y te enviaremos un mail, para reconfigurar tu nueva contraseña. Luego volverás a realizar el login con tu nueva contraseña. Confirma?",
        context,
        function() {
          axiosHelpers.axiosPost(
            "Account/CrearSolicitudCambioPassword",
            {
              Identifier: context.$store.getters.CUIT_CUIL,
              AvoidCodeValidation: true
            },
            context,
            function(data) {
              if (data.ResponseVM.Resultado) {
                notificationHelpers.showSuccess(
                  "Mail enviado!",
                  "Se ha enviado un mail a " +
                    data.ResponseVM.EmailDestino +
                    " con un enlace para que pueda cambiar su contraseña",
                  context
                );
                context.logout();
              }
            }
          );
        }
      );
    }
  }
};
</script>


<style scoped>
</style>